/* eslint-disable no-console */
import { BooleanCheck, CheckResultRenderer } from "@backstage/plugin-tech-insights";
import { Typography } from "@material-ui/core";
import React from "react";

export const otkRenderer: CheckResultRenderer = {
  type: "json-rules-engine",
  component: (checkRes) => {
    try {
      const id = checkRes.check.id
      console.log(id)
      console.log(!!checkRes.facts[id].value)
      switch (checkRes.facts[id].type) {
        case "boolean":
          return <BooleanCheck checkResult={checkRes} />
        case "integer":
          return <Typography align="center" variant="h5" color={checkRes.result ? "primary" : "error"}>{!checkRes.facts[id].value ? "N/A": checkRes.facts[id].value }</Typography>
        case "float":
          return <Typography align="center" variant="h5" color={checkRes.result ? "primary" : "error"}>{!checkRes.facts[id].value ? "N/A": checkRes.facts[id].value }</Typography>
          default:
          return <BooleanCheck checkResult={checkRes} />
      }
    } catch (error) {
      console.error(error)
      return <BooleanCheck checkResult={checkRes} />
    }
  },
}